// extracted by mini-css-extract-plugin
export default {"boardRow":"ttt_boardRow__NoxAA","status":"ttt_status__jK0b3","square":"ttt_square__qdHRw","game":"ttt_game__P33Vh","gameInfo":"ttt_gameInfo__BDl90"};